import { palette } from "../palette";
export const card = {
  default: {
    borderRadius: "4px",
    padding: "24px"
  },
  bordered: {
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: palette.gray.lighter,
    boxShadow: "none"
  }
};